import type { PropsWithAriaLabel, PropsWithAriaLabelledBy } from './aria-label'

interface PropsWithLabel {
  label: string
  'aria-label'?: undefined
  'aria-labelledby'?: undefined
}

interface InternalPropsWithAriaLabel extends PropsWithAriaLabel {
  label?: undefined
}

interface InternalPropsWithAriaLabelledBy extends PropsWithAriaLabelledBy {
  label?: undefined
}

export enum ControlFieldAlign {
  left = 'left',
  right = 'right',
}

export type ControlFieldAlignType = `${ControlFieldAlign}`
export type ElementWithOptionalLabelType<T> =
  | (T & PropsWithLabel)
  | (T & InternalPropsWithAriaLabelledBy)
  | (T & InternalPropsWithAriaLabel)
